"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EbmlElementType;
(function (EbmlElementType) {
    EbmlElementType["Master"] = "m";
    EbmlElementType["UnsignedInt"] = "u";
    EbmlElementType["Integer"] = "i";
    EbmlElementType["String"] = "s";
    EbmlElementType["UTF8"] = "8";
    EbmlElementType["Binary"] = "b";
    EbmlElementType["Float"] = "f";
    EbmlElementType["Date"] = "d";
})(EbmlElementType = exports.EbmlElementType || (exports.EbmlElementType = {}));
